import { createContext, useContext } from "react";
import { Prefetched } from "../hooks/usePrefetchData";

export interface ShareContextType {
	prefetched: Prefetched;
	onComplete?: () => void;
	onCopy?: () => void;
	onCopyClear?: () => void;
	onSuccess?: () => void;
	displayIconText?: boolean;
}
export const ShareContext = createContext<ShareContextType | undefined>(undefined);

export const useShareContext = (contextProp?: ShareContextType) => {
	const context = useContext(ShareContext);
	if (contextProp) return contextProp;
	if (!context) {
		throw new Error(
			"useShareContext must be used within a ShareContextProvider or with context prop",
		);
	}
	return context;
};
